import mobileCarousel from '../utils/mobileCarousel';

mobileCarousel(
    'employee-history__mobile-carousel',
    'swiper-pagination-employee-history',
    1.4,
    24
);
